import React from "react";
import DateRangeSelector, { RANGE_BLANK } from "./DateRangeSelector";

const periodTriggerStyles = (isOpen, hasValue) => {
    return Object.assign({}, {
        backgroundColor: "white",
        color: "#aaa",
        border: "1px solid #ccc",
        borderRadius: 4,
        padding: 8
    }, isOpen && {
        borderRadius: "4px 4px 0 0",
        backgroundColor: "rgb(243,243,243)"
    }, hasValue && {
        color: "black"
    });
};

class DateRange extends React.Component {
    constructor() {
        super();
        this.state = { selectorIsVisible: false };
        this._handleClick = this._handleClick.bind(this);
        this._handleClear = this._handleClear.bind(this);
        this._hideDateRangeSelector = this._hideDateRangeSelector.bind(this);
    }

    render() {
        return (
            <span style={{position: "relative"}}>
                <button style={periodTriggerStyles(this.state.selectorIsVisible, this.props.value !== RANGE_BLANK)} onClick={this._handleClick}>
                    <span className="x-value">{this.props.value === RANGE_BLANK ? "Select..." : this.props.value.name}</span>
                    {
                        this.props.value !== RANGE_BLANK ?
                            <span ref="clear" style={{marginLeft: 10}} className="x-clear Select-clear" onClick={this._handleClear}>&times;</span>
                            : null
                    }
                    <div className="Select-arrow" style={{marginLeft: 10}} />
                </button>
                { this.state.selectorIsVisible ?
                    <DateRangeSelector timeframe={ this.props.value }
                                       onSelect={ this.props.onChange }
                                       closeMenu={ this._hideDateRangeSelector } />
                    : null }
            </span>
        );
    }

    _handleClick(e) {
        if (e.target !== this.refs.clear) {
            this.setState({ selectorIsVisible: !this.state.selectorIsVisible });
        }
    }

    _handleClear() {
        this.props.onChange(RANGE_BLANK);
        this._hideDateRangeSelector();
    }

    _hideDateRangeSelector() {
        this.setState({ selectorIsVisible: false });
    }
}
DateRange.propTypes = {
    onChange: React.PropTypes.func,
    value: React.PropTypes.object
};

export default DateRange



/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/components/DateRange.js
 **/